import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Privacy from './Privacy';
import Terms from './Terms';
import Careers from './Careers';
import CareerRole from './CareerRole';
import Supporter from './Supporter';
import Support from './Support';
import Admin from './Admin';
import reportWebVitals from './reportWebVitals';

const PAGES = { '/privacy': Privacy, '/terms': Terms, '/careers': Careers, '/support': Support, '/admin': Admin };
const path = window.location.pathname.replace(/\/+$/, '');
const roleMatch = path.match(/^\/careers\/([^/]+)$/);
const supporterPath = /^\/s(?:\/|$)/.test(path);
const supporterMatch = path.match(/^\/s\/([0-9a-f]{40})$/i);
const Page = PAGES[path] || App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {roleMatch ? (
      <CareerRole roleId={decodeURIComponent(roleMatch[1])} />
    ) : supporterPath ? (
      <Supporter token={supporterMatch?.[1].toLowerCase() || null} />
    ) : (
      <Page />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
